import axios from 'axios';
import { backendBaseUrl } from '../utils/platformBasedInfo';

export const ENDPOINT_UPLOAD_TOKEN = `${backendBaseUrl}/files/upload-token`;

// Mints a short-lived, opportunity-scoped upload token (HI-2) so FilePond's
// /files/upload call is authorized. Apply flows always possess the
// {opportunity, account, contact} publicId triple (from the wizard / resume
// link), so we mint via the backend's DB-correlated-triple branch — this works
// for BOTH the logged-in bank-upload flow and the pre-auth / embedded resume
// flows without needing an Auth0 token that FilePond can't attach anyway.
//
// Best-effort: the backend is log-only until enforcement, so a failed mint
// simply means the upload proceeds without the header for now.
export const mintUploadToken = async ({
  opportunityId,
  accountId,
  contactId,
}: {
  opportunityId?: string;
  accountId?: string;
  contactId?: string;
}): Promise<string | undefined> => {
  if (!opportunityId) return undefined;
  try {
    const res = await axios.post(ENDPOINT_UPLOAD_TOKEN, {
      opportunityId,
      accountId,
      contactId,
    });
    return res?.data?.data?.uploadToken as string | undefined;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[uploadToken] failed to mint upload token', err);
    return undefined;
  }
};
